import type { PublicSeoLanguage } from './publicSeoPages';
import translations from '../locales/translations.json';

export const OFFER_IDS = ['1', '2'] as const;
export type OfferId = typeof OFFER_IDS[number];

export function buildOfferPath(offerId: OfferId, language: PublicSeoLanguage): string {
  if (!OFFER_IDS.includes(offerId)) throw new Error('Invalid offer ID');
  return `${language === 'en' ? '/en' : ''}/offer/${offerId}`;
}

export function parseOfferPath(path: string): { offerId: OfferId; language: PublicSeoLanguage } | null {
  const match = /^\/(en\/)?offer\/([12])\/?$/.exec(new URL(path, 'https://palen-adr.eu').pathname);
  return match ? { offerId: match[2] as OfferId, language: match[1] ? 'en' : 'fr' } : null;
}

export function buildOfferSeoHeadMarkup(offerId: OfferId, language: PublicSeoLanguage): string {
  const labels = translations[language].billing.landing;
  const plan = offerId === '1' ? labels.proOfferTitle : labels.enterprise.title;
  const title = language === 'en' ? `Palen ${plan} plan` : `Offre ${plan} Palen`;
  const description = language === 'en'
    ? `Discover the Palen ${plan} plan and choose monthly or annual billing.`
    : `Découvrez l’offre ${plan} Palen et choisissez un abonnement mensuel ou annuel.`;
  return [
    `<title>${title}</title>`,
    '<meta name="robots" content="noindex,nofollow" />',
    `<meta name="description" content="${description}" />`,
    `<link rel="canonical" href="https://palen-adr.eu${buildOfferPath(offerId, language)}" />`,
  ].join('\n');
}
